import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PipeToBrPipe } from './pipe-to-br.pipe';
import { PricePipe } from './price.pipe';
import { AssetPipe } from './asset.pipe';

@NgModule({
  declarations: [PipeToBrPipe, PricePipe, AssetPipe],
  imports: [CommonModule],
  exports: [PipeToBrPipe, PricePipe, AssetPipe],
})
export class PipesModule {}
